import GeneratingOverlay from "@/components/GeneratingOverlay/GeneratingOverlay";

type FullScreenLoaderProps = {
  isLoading: boolean;
  estimatedSeconds?: number;
};

const FullScreenLoader = (props: FullScreenLoaderProps) => {
  return (
    <GeneratingOverlay
      isVisible={props.isLoading}
      estimatedSeconds={3}
      message={"Loading dashboard ..."}
      displayTime={false}
    />
  );
};

export default FullScreenLoader;
